<template>
    <div class="unpack-left">
        <h1>
            <span class="t-p-l-20 t-p-r-20 u-line-2">{{ title }}</span>
            <!-- <span>仿写记录</span> -->
        </h1>
        <!-- 列表 -->
        <div class="apart-list">
            <dl class="apart-list__item" v-for="(item, index) in list" :key="item.id" @click.stop="selected(item)">
                <dt>
                    <label class="flex-row cursor_1" >
                        <p class="flex-1 u-line-1" :title="item.title">{{ item.title }}</p>
                        <span @click.stop="delChapterClick(item.id, item)" title="删除" class="del"><i
                                class="el-icon-delete"></i></span>
                        <span v-if="!item.selected" class="circle"></span>
                        <img v-else src="@/assets/image/apart/selected-apart.png" width="20" height="20" />
                    </label>

                </dt>
                <dd style="position: relative;">
                    <span>{{ item.wordCount }}字</span>
                    <span class="ok" v-if="item.status">已转换</span>
                    <span class="no" v-else>未转换</span>
                </dd>
            </dl>
        </div>
        <!-- 分页 -->
        <!-- <div class="apart-page">
            <el-pagination v-model:current-page="pageNum" v-model:page-size="pageSize"
                background :pager-count="5" layout="prev, pager, next" :total="total" @current-change="currentPage" />
        </div> -->
        <div class="apart-page">
            <pagination ref="pagination" v-if="total" :totalItems="total" @page-changed="currentPage"></pagination>
        </div>
        <loadingStatus v-if="loading"></loadingStatus>
        <popup ref="delPopup" @confirm="confirm"></popup>
    </div>
</template>
<script>
import apart from '@/api/apart';
import throttle from '@/utils/throttle'
import loadingStatus from '@/components/loading_status.vue' //加载效果
import popup from '@/components/dongeb/popup.vue';
import pagination from '@/components/dongeb/pagination.vue'
export default {
    components: {
        loadingStatus, popup, pagination
    },
    data() {
        return {
            pageNum: 1,
            pageSize: 10,
            total: 0,
            loading: false,
            list: [],
            paginationKey: 0,
        }
    },
    computed: {
        title() {
            return sessionStorage.getItem('title')
        }
    },
    created() {
        if (this.$attrs.id) {
            this.init(true);
        }
    },
    methods: {
        init(init = false) {
            this.loading = true
            apart.chapterList({ id: this.$attrs.id, pageNum: this.pageNum, pageSize: this.pageSize, type: 1 }).then(res => {
                if (res.code === 200) {
                    this.total = res.total
                    this.list = res.rows.map(v => ({
                        ...v,
                        selected: false
                    }))
                    //初始化第一个章节
                    if (init && this.list.length > 0) {
                        this.list[0].selected = true
                        this.chapterDetail(this.list[0].id)
                    }
                }
            }).finally(() => {
                this.loading = false
            })
        },
        refreshList(id, curItem) {
            apart.chapterList({ id: this.$attrs.id, pageNum: this.pageNum, pageSize: this.pageSize, type: 1 }).then(res => {
                if (res.code === 200) {
                    this.total = res.total
                    this.list = res.rows.map(item => {
                        if (item.id === id) {
                            item.selected = true
                            this.chapterDetail(id)
                        } else {
                            item.selected = false
                        }
                        return item;
                    })
                    //初始化第一个章节
                    if (curItem.selected && this.list.length > 0) {
                        this.list[0].selected = true
                        this.chapterDetail(this.list[0].id)
                    }
                }
            })
        },
        //删除后的刷新
        delRefreshList(curItem) {
             this.loading = true
            apart.chapterList({ id: this.$attrs.id, pageNum: this.pageNum, pageSize: this.pageSize, type: 1 }).then(res => {
                if (res.code === 200) {
                    this.total = res.total
                    //先获取章节列表有选中的
                    const curSelectItem = this.list.filter(item => item.selected)
                    console.log('curSelectItem=', curSelectItem)
                    //如果列表上有选中的就进行勾选
                    this.list = res.rows.map(v => {
                        if (curSelectItem.length > 0 && v.id === curSelectItem[0].id) {
                            v.selected = true
                        } else {
                            v.selected = false
                        }
                        return v
                    })

                    //删除后的刷新逻辑
                    if (this.list.length > 0) {
                        //如果删除的是勾选的章节，那么就初始化第一个章节
                        if (curItem && curItem.selected) {
                            this.list[0].selected = true
                            this.chapterDetail(this.list[0].id)
                        }
                    }

                }
            }).finally(() => {
                this.loading = false
            })
        },
        //获取章节详情信息
        chapterDetail(chapterId) {
            apart.chapterDetail({ chapterId, type: 1 }).then(res => {
                if (res.code === 200) {
                    this.$emit('getDetail', res.data)
                }
            }).finally(() => {
                setTimeout(() => {
                    this.loading = false
                }, 500);
            })
        },
        selected(item) {
            throttle(() => {
                let apartStatus = JSON.parse(sessionStorage.getItem('apartStatus'))
                if (apartStatus) {
                    if (apartStatus.status !== 'ok') {
                        this.$refs.delPopup.openPrompt(10);
                        return;
                    } else {
                        sessionStorage.removeItem('apartStatus')
                        sessionStorage.removeItem(apartStatus.id + '_csText')
                        sessionStorage.removeItem(apartStatus.id + '_fxText')
                    }
                }

                this.list.forEach(v => {
                    if (item.id === v.id) {
                        item.selected = true
                        this.loading = true
                        this.chapterDetail(item.id)
                    } else {
                        v.selected = false
                    }
                })
            }, 200)
        },
        confirm() {
            this.$refs.delPopup.close()
        },
        currentPage(e) {
            let apartStatus = JSON.parse(sessionStorage.getItem('apartStatus'))
            if (apartStatus) {
                if (apartStatus.status !== 'ok') {
                    this.$refs.delPopup.openPrompt(10);
                    return;
                }
            } else {
                sessionStorage.removeItem('apartStatus')
            }
            this.$refs.pagination.currentPage = e
            this.pageNum = e
            this.init(true)
        },
        delChapterClick(id, item) {
            let apartStatus = JSON.parse(sessionStorage.getItem('apartStatus'))
            if (apartStatus) {
                if (apartStatus.status !== 'ok') {
                    this.$refs.delPopup.openPrompt(10);
                    return;
                }
            }
            this.$confirm('确定删除该章节吗？', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                apart.delChapter({ chapterId: id, type: 1 }).then(res => {
                    if (res.code === 200) {
                        this.$message.success('删除成功')
                        this.delRefreshList(item)
                    } else {
                        this.$message.warning(res.msg)
                    }
                })
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });
            });
        }
    }
}
</script>
<style lang="scss" scoped>
p,
h1,
dl,
dt,
dd {
    margin: 0;
    padding: 0;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active {
    background-color: var(--tech-primary);
    outline: none;
}

::v-deep .el-pager li {
    padding: 0 4px;
    outline: 1px solid #CED4DB;
    font-size: 13px;
    min-width: 35.5px;
    height: 28px;
    line-height: 28px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 2px;
}

::v-deep .el-pagination.is-background .el-pager li {
    color: #2F3133;
    font-size: 14px;
    background-color: #ffffff;
}

::v-deep .el-pagination.is-background .btn-prev {
    background-color: transparent;
}

::v-deep .el-pagination.is-background .btn-next {
    background-color: transparent;
}

.ok {
    color: #01CC7A;
    margin-left: 8px;
}

.no {
    color: var(--tech-primary);
    margin-left: 8px;
}

.del {
    display: none;
    margin-right: 8px;
    font-size: 20px;
    transition: all 0.3s;
    cursor: pointer;
}

.unpack-left {
    box-sizing: border-box;
    font-family: Microsoft YaHei, Microsoft YaHei;
    width: 18.06vw;
    background-color: #ffffff;
    box-shadow: 0px 0px 8px 0px rgba(117, 53, 0, 0.06);
    border-radius: 8px 0px 0px 0px;
    display: flex;
    flex-direction: column;

    .apart-list {
        padding: 22px 0;
        overflow: auto;
        flex: 1;
        @include no_scrollbar();

        .apart-list__item {
            padding: 10px 10px 20px 20px;
        }

        dl,
        dt,
        dd {
            margin: 0;
            padding: 0;
        }

        dl {
            margin-bottom: 14px;

            dt {
                font-weight: 400;
                font-size: 16px;
                color: #0A0A0A;
                line-height: 16px;

                .circle {
                    width: 20px;
                    height: 20px;
                    background: #E9E9E9;
                    border-radius: 4px;
                }
            }

            dd {
                font-weight: 400;
                font-size: 14px;
                line-height: 14px;
                margin-top: 4px;

                span:first-child {
                    color: #666666;
                }

            }
        }
    }

    .apart-list__item {
        &:hover {
            background-color: var(--tech-btn-bg);

            .del {
                opacity: 1;
                display: block;
            }
        }
    }

    .apart-page {
        height: 66px;
        background: #FFFFFF;
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;

        &::before {
            content: " ";
            position: absolute;
            top: 0;
            left: 0;
            height: 1px;
            width: 100%;
            background-color: #EEEEEE;
        }
    }
}

h1 {
    height: 64px;
    display: flex;
    align-items: center;
    font-weight: bold;
    font-size: 18px;
    color: #0A0A0A;
    width: 100%;
    position: relative;

    &::before {
        content: " ";
        position: absolute;
        bottom: 0;
        left: 0;
        height: 1px;
        width: 100%;
        background-color: #E6EBF0;
    }
}

p {
    margin: 0;
}
</style>